import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../Header';
import AdminForm from "./AdminForm";
import RewardsTabbedForm from "./RewardsTabbedForm";
import AdminIndex from "./AdminIndex";

const PersonnelAdminIndex = () => {



  return (
    <>
      <Header icon={"fa-solid fa-users fa-xl mx-2"}  label={"Personnel Admin/Form"}/>
      <main id="main" className="main">
        <section className="section ">
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12'>
              <div className='card'>

                <div className='card-body'>


                  <AdminIndex />

                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>

  )
}
export default PersonnelAdminIndex;
